import { exportTestInstance, managementTestInstance } from '../axios';

const getRoles = (pagination: any, sortOrder: any) =>
  managementTestInstance.post('/security/roles/list', { pagination, sortOrder });

const cloneRole = (roleId: any, newRoleName: any) =>
  managementTestInstance.post('/security/roles/clone', { roleId, newRoleName });

const getModules = () =>
  managementTestInstance.post('/security/modules/list', { pagination: { pageSize: 100, pageNumber: 1 }, sortOrder: null });

const getRoleModules = (rolId: any) =>
  managementTestInstance.post('/security/roles/modules/list', { rolId, pagination: { pageSize: 100, pageNumber: 1 }, sortOrder: null });

const getRolePermissions = (rolId: any, pagination: any, sortOrder: any, filters: any) =>
  managementTestInstance.post('/security/roles/permissions/list', { rolId, pagination, sortOrder, filters });

const createNewRole = (name: any, modules: any) =>
  managementTestInstance.post('/security/roles/permissions/add', {
    roles: [{
      name,
      modules,
    }],
  });

const updateRolePermissions = (id: any, applications: any) =>
  managementTestInstance.put('/security/roles/permissions/update', {
    roles: [{
      id,
      applications,
    }],
  });

const updateRoleModules = (id: any, modules: any) =>
  managementTestInstance.put('/security/roles/permissions/update', {
    roles: [{
      id,
      modules,
    }],
  });

const getUsers = (pagination: any, sortOrder: any, filters: any) =>
  managementTestInstance.post('/user/list', { pagination, sortOrder, filters });

const generateAuthorizationReportExcel = (input: any) =>
  exportTestInstance.post('/authorization-report/export-excel', input, {
    headers:
    {
      'Content-Disposition': 'attachment; filename=template.xlsx',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  });

const generateAuthorizationReportPdf = (input: any) =>
  exportTestInstance.post('/authorization-report/export-pdf', input, {
    headers: {
      'Content-Disposition': 'attachment; filename=template.pdf',
      'Content-Type': 'application/pdf',
    },
    responseType: 'arraybuffer',
  });

const printRolePermissionsExcel = (input: any) =>
  exportTestInstance.post('/role-permission-report/export-excel', input, {
    headers:
    {
      'Content-Disposition': 'attachment; filename=template.xlsx',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  });

const printRolePermissionsPdf = (input: any) =>
  exportTestInstance.post('/role-permission-report/export-pdf', input, {
    headers: {
      'Content-Disposition': 'attachment; filename=template.pdf',
      'Content-Type': 'application/pdf',
    },
    responseType: 'arraybuffer',
  });

const listMakes = (input: any) =>
  managementTestInstance.post('/maintain-make', input);

const addMake = (input: any) =>
  managementTestInstance.post('/maintain-make/add', input);

const updateMake = (input: any) =>
  managementTestInstance.put('/maintain-make', input);

const deleteMakes = (ids: Array<any>) =>
  managementTestInstance.delete('/maintain-make', { data: { ids } });

const listModels = (input: any) =>
  managementTestInstance.post('/maintain-model', input);

const addModel = (input: any) =>
  managementTestInstance.post('/maintain-model/add', input);

const updateModel = (input: any) =>
  managementTestInstance.put('/maintain-model', input);

const deleteModels = (ids: Array<any>) =>
  managementTestInstance.delete('/maintain-model', { data: { ids } });

const listFootprint = (input: any) =>
  managementTestInstance.post('/maintain-get-footprint', input);

const addFootprint = (input: any) =>
  managementTestInstance.post('/maintain-add-footprint', input);

const updateFootprint = (input: any) =>
  managementTestInstance.put('/maintain-update-footprint', input);

const deleteFootprints = (ids: Array<any>) =>
  managementTestInstance.delete('/maintain-delete-footprint', { data: { ids } });

const getWheelPositions = (data: any) =>
  managementTestInstance.post('/footprint-wheelpositions', data);

const availableWheelPositions = (data: any) =>
  managementTestInstance.post('/available-wheelpositions', data);

const addWheelPositions = (data: any) =>
  managementTestInstance.post('/wheelpositions/add', data);

const addMultipleWheelPositions = (data: any) =>
  managementTestInstance.post('/multiple-wheelpositions/add', data);

const updateWheelPositions = (data: any) =>
  managementTestInstance.put('/wheelpositions/update', data);

const deleteWheelPositions = (data: any) =>
  managementTestInstance.delete('/wheelpositions/delete', { data });

const uploadImage = (footprintId: string, file: any) => {
  const formData = new FormData();
  formData.append('FootprintId', footprintId);
  formData.append('file', file);

  return managementTestInstance.post('/maintain-footprint/upload', formData);
};

const loadImage = (footprintId: any) =>
  managementTestInstance.post('/maintain-footprint/load-image', footprintId);

const deleteImage = (input: any) =>
  managementTestInstance.post('/maintain-footprint/clear-image', input);

const getUserStatuses = () =>
  managementTestInstance.get('/user/statuses');

const updateUsers = (payload: any) =>
  managementTestInstance.put('/user/update', payload);

export default {
  getRoles,
  cloneRole,
  getModules,
  getRoleModules,
  getRolePermissions,
  createNewRole,
  updateRoleModules,
  updateRolePermissions,
  getUsers,
  printRolePermissionsExcel,
  printRolePermissionsPdf,
  generateAuthorizationReportExcel,
  generateAuthorizationReportPdf,
  listMakes,
  addMake,
  updateMake,
  deleteMakes,
  listModels,
  addModel,
  updateModel,
  deleteModels,
  listFootprint,
  addFootprint,
  updateFootprint,
  deleteFootprints,
  getWheelPositions,
  availableWheelPositions,
  addWheelPositions,
  addMultipleWheelPositions,
  updateWheelPositions,
  deleteWheelPositions,
  uploadImage,
  loadImage,
  deleteImage,
  getUserStatuses,
  updateUsers,
};
